"use strict";

/*==============================================================================*
*TRESTLE™ W004
*POPUP TOOL — MENSTRUAL PATTERN CHECKER
*==============================================================================*/

window.TRESTLE_W004_TOOLS =
window.TRESTLE_W004_TOOLS || {};


window.TRESTLE_W004_TOOLS.menstrual_pattern_checker = {


/*==============================================================================*
*RENDER
*==============================================================================*/

render(){

    return `

    <div class="tr-w004-menstrual-tool">

        <div class="diafemme-cycle-tool">


            <p class="intro">

                Understand your cycle better with instant insights.

            </p>


            <div class="df-disclaimer">

                <strong>Important:</strong>

                This Menstrual Pattern Checker is designed for educational
                and informational purposes only. Period dates, ovulation
                estimates, fertile windows, and wellness insights are based
                on general calculations and may not accurately reflect your
                individual cycle.

            </div>


            <!--==============================================================
            CYCLE DETAILS
            ===============================================================-->

            <div class="df-section">

                <h3>Cycle Details</h3>


                <label class="df-label">

                    Last Period Start Date

                </label>

                <input
                type="date"
                class="df-input"
                data-cycle-period-date>


                <label class="df-label">

                    Average Cycle Length

                </label>

                <select
                class="df-select"
                data-cycle-length>

                    <option value="21">21 Days</option>
                    <option value="22">22 Days</option>
                    <option value="23">23 Days</option>
                    <option value="24">24 Days</option>
                    <option value="25">25 Days</option>
                    <option value="26">26 Days</option>
                    <option value="27">27 Days</option>
                    <option value="28" selected>28 Days</option>
                    <option value="29">29 Days</option>
                    <option value="30">30 Days</option>
                    <option value="31">31 Days</option>
                    <option value="32">32 Days</option>
                    <option value="33">33 Days</option>
                    <option value="34">34 Days</option>
                    <option value="35">35 Days</option>

                </select>


                <label class="df-label">

                    Period Duration

                </label>

                <select
                class="df-select"
                data-cycle-duration>

                    <option>2 Days</option>
                    <option>3 Days</option>
                    <option>4 Days</option>
                    <option selected>5 Days</option>
                    <option>6 Days</option>
                    <option>7 Days</option>
                    <option>8 Days</option>
                    <option>9 Days</option>
                    <option>10 Days</option>

                </select>

            </div>


            <!--==============================================================
            CURRENT SYMPTOMS
            ===============================================================-->

            <div class="df-section">

                <h3>Current Symptoms</h3>


                <div class="df-checkbox-group">

                    <label>
                        <input type="checkbox" value="cramps">
                        Severe Cramps
                    </label>

                    <label>
                        <input type="checkbox" value="heavy">
                        Heavy Bleeding
                    </label>

                    <label>
                        <input type="checkbox" value="light">
                        Light Bleeding
                    </label>

                    <label>
                        <input type="checkbox" value="acne">
                        Acne
                    </label>

                    <label>
                        <input type="checkbox" value="bloating">
                        Bloating
                    </label>

                    <label>
                        <input type="checkbox" value="mood">
                        Mood Swings
                    </label>

                    <label>
                        <input type="checkbox" value="fatigue">
                        Fatigue
                    </label>

                    <label>
                        <input type="checkbox" value="headaches">
                        Headaches
                    </label>

                    <label>
                        <input type="checkbox" value="sleep">
                        Sleep Disturbance
                    </label>

                    <label>
                        <input type="checkbox" value="irregular">
                        Irregular Periods
                    </label>

                </div>

            </div>


            <!--==============================================================
            ADDITIONAL FACTORS
            ===============================================================-->

            <div class="df-section">

                <h3>Additional Factors</h3>


                <label class="df-label">

                    Age Group

                </label>

                <select
                class="df-select"
                data-cycle-age>

                    <option>Under 20</option>
                    <option selected>20–35</option>
                    <option>36–45</option>
                    <option>46–55</option>
                    <option>55+</option>

                </select>

            </div>


            <!--==============================================================
            BUTTON
            ===============================================================-->

            <button
            type="button"
            class="df-btn"
            data-cycle-check>

                Check My Pattern

            </button>


            <!--==============================================================
            RESULTS
            ===============================================================-->

            <div
            class="df-results"
            data-cycle-results
            hidden>
            </div>


        </div>

    </div>

    `;

},


/*==============================================================================*
*INIT
*==============================================================================*/

init(root){

    if(!root){

        return;

    }


    const periodDateInput =

        root.querySelector(

            "[data-cycle-period-date]"

        );


    const cycleLengthInput =

        root.querySelector(

            "[data-cycle-length]"

        );


    const checkButton =

        root.querySelector(

            "[data-cycle-check]"

        );


    const results =

        root.querySelector(

            "[data-cycle-results]"

        );


    if(

        !periodDateInput ||
        !cycleLengthInput ||
        !checkButton ||
        !results

    ){

        return;

    }


/*==============================================================================*
*FORMAT DATE
*==============================================================================*/

    const formatDate = (date)=>{

        return date.toLocaleDateString(

            "en-IN",

            {

                day:"numeric",

                month:"long",

                year:"numeric"

            }

        );

    };


/*==============================================================================*
*GENERATE REPORT
*==============================================================================*/

    const generateReport = ()=>{


        const periodDate =

            periodDateInput.value;


        if(!periodDate){

            alert(

                "Please select your last period start date."

            );

            return;

        }


        const cycleLength =

            parseInt(

                cycleLengthInput.value,

                10

            );


        const lastDate =

            new Date(

                periodDate + "T00:00:00"

            );


        const nextPeriod =

            new Date(

                lastDate

            );


        nextPeriod.setDate(

            nextPeriod.getDate() +

            cycleLength

        );


        const ovulation =

            new Date(

                nextPeriod

            );


        ovulation.setDate(

            ovulation.getDate() - 14

        );


        const fertileStart =

            new Date(

                ovulation

            );


        fertileStart.setDate(

            fertileStart.getDate() - 4

        );


        const fertileEnd =

            new Date(

                ovulation

            );


        fertileEnd.setDate(

            fertileEnd.getDate() + 1

        );


/*==============================================================================*
*SYMPTOM INSIGHTS
*==============================================================================*/

        const insights = [];


        const selectedSymptoms =

            root.querySelectorAll(

                ".df-checkbox-group input:checked"

            );


        selectedSymptoms.forEach(

            (box)=>{


                switch(box.value){


                    case "acne":

                        insights.push(

                            "Acne together with irregular cycles is commonly reported among women with PCOS."

                        );

                        break;


                    case "irregular":

                        insights.push(

                            "Irregular cycles may occur due to hormonal changes, stress, PCOS or perimenopause."

                        );

                        break;


                    case "heavy":

                        insights.push(

                            "Persistent heavy bleeding should be discussed with a healthcare professional."

                        );

                        break;


                    case "bloating":

                        insights.push(

                            "Bloating is a common premenstrual symptom."

                        );

                        break;


                    case "mood":

                        insights.push(

                            "Mood changes often occur during the luteal phase before menstruation."

                        );

                        break;


                    case "fatigue":

                        insights.push(

                            "Fatigue around the menstrual cycle is common but persistent fatigue deserves attention."

                        );

                        break;


                    case "cramps":

                        insights.push(

                            "Severe cramps that interfere with daily life may warrant medical evaluation."

                        );

                        break;


                    case "headaches":

                        insights.push(

                            "Hormonal fluctuations may contribute to menstrual headaches."

                        );

                        break;


                    case "sleep":

                        insights.push(

                            "Sleep disturbances can become more noticeable before menstruation."

                        );

                        break;

                }

            }

        );


        if(insights.length === 0){

            insights.push(

                "No specific symptom pattern was identified from the selected inputs."

            );

        }


/*==============================================================================*
*RESULT
*==============================================================================*/

        results.innerHTML = `

            <h3>Cycle Overview</h3>


            <p>

                <strong>Next Expected Period:</strong>

                <br>

                ${formatDate(nextPeriod)}

            </p>


            <p>

                <strong>Estimated Ovulation:</strong>

                <br>

                ${formatDate(ovulation)}

            </p>


            <p>

                <strong>Estimated Fertile Window:</strong>

                <br>

                ${formatDate(fertileStart)}
                to
                ${formatDate(fertileEnd)}

            </p>


            <h3>Pattern Observations</h3>


            <ul>

                ${insights

                    .map(

                        (item)=>

                            `<li>${item}</li>`

                    )

                    .join("")}

            </ul>


            <h3>Diafemme Wellness Insight</h3>


            <p>

                Balanced nutrition, regular physical activity,
                stress management and good sleep habits may help
                support overall menstrual wellbeing.

            </p>


            <div class="df-disclaimer">

                <strong>Disclaimer:</strong>

                This tool provides general educational information
                only and does not diagnose, treat or prevent any
                medical condition. Always consult a qualified
                healthcare professional regarding menstrual concerns
                or reproductive health issues.

            </div>

        `;


        results.hidden = false;


        results.scrollIntoView({

            behavior:"smooth",

            block:"nearest"

        });

    };


/*==============================================================================*
*EVENT
*==============================================================================*/

    checkButton.addEventListener(

        "click",

        generateReport

    );

}

};